/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeFormat } from './TimeFormat';
import {
    TimeFormatFromJSON,
    TimeFormatFromJSONTyped,
    TimeFormatToJSON,
    TimeFormatToJSONTyped,
} from './TimeFormat';
import type { WindowsTimezone } from './WindowsTimezone';
import {
    WindowsTimezoneFromJSON,
    WindowsTimezoneFromJSONTyped,
    WindowsTimezoneToJSON,
    WindowsTimezoneToJSONTyped,
} from './WindowsTimezone';
import type { Language } from './Language';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
    LanguageToJSONTyped,
} from './Language';
import type { DateFormat } from './DateFormat';
import {
    DateFormatFromJSON,
    DateFormatFromJSONTyped,
    DateFormatToJSON,
    DateFormatToJSONTyped,
} from './DateFormat';
import type { Mode } from './Mode';
import {
    ModeFromJSON,
    ModeFromJSONTyped,
    ModeToJSON,
    ModeToJSONTyped,
} from './Mode';
import type { LengthUnit } from './LengthUnit';
import {
    LengthUnitFromJSON,
    LengthUnitFromJSONTyped,
    LengthUnitToJSON,
    LengthUnitToJSONTyped,
} from './LengthUnit';

/**
 * This struct represents all publicly accessible settings. This is a "singleton": there's only a single row on each instance. The backend does not create or delete rows, it only updates this one row.
 * @export
 * @interface PublicSetting
 */
export interface PublicSetting {
    /**
     * 
     * @type {string}
     * @memberof PublicSetting
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof PublicSetting
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PublicSetting
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof PublicSetting
     */
    instanceName: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSetting
     */
    logoId?: string | null;
    /**
     * 
     * @type {Language}
     * @memberof PublicSetting
     */
    defaultLanguage: Language;
    /**
     * 
     * @type {WindowsTimezone}
     * @memberof PublicSetting
     */
    defaultTimezone: WindowsTimezone;
    /**
     * 
     * @type {DateFormat}
     * @memberof PublicSetting
     */
    defaultDateFormat: DateFormat;
    /**
     * 
     * @type {TimeFormat}
     * @memberof PublicSetting
     */
    defaultTimeFormat: TimeFormat;
    /**
     * 
     * @type {LengthUnit}
     * @memberof PublicSetting
     */
    defaultLengthUnit: LengthUnit;
    /**
     * Indicates whether the necessary configuration is set up to use SSO (Single Sign-On).
     * @type {boolean}
     * @memberof PublicSetting
     */
    openidConnectConfigured: boolean;
    /**
     * Indicates whether ELOfleet, ELOfusion, or ELOshield is enabled,
     * @type {Mode}
     * @memberof PublicSetting
     */
    mode: Mode;
    /**
     * Whether PIN authentication for fleet users is enabled.
     * @type {boolean}
     * @memberof PublicSetting
     */
    pinAuthenticationEnabled: boolean;
}



/**
 * Check if a given object implements the PublicSetting interface.
 */
export function instanceOfPublicSetting(value: object): value is PublicSetting {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('instanceName' in value) || value['instanceName'] === undefined) return false;
    if (!('defaultLanguage' in value) || value['defaultLanguage'] === undefined) return false;
    if (!('defaultTimezone' in value) || value['defaultTimezone'] === undefined) return false;
    if (!('defaultDateFormat' in value) || value['defaultDateFormat'] === undefined) return false;
    if (!('defaultTimeFormat' in value) || value['defaultTimeFormat'] === undefined) return false;
    if (!('defaultLengthUnit' in value) || value['defaultLengthUnit'] === undefined) return false;
    if (!('openidConnectConfigured' in value) || value['openidConnectConfigured'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('pinAuthenticationEnabled' in value) || value['pinAuthenticationEnabled'] === undefined) return false;
    return true;
}

export function PublicSettingFromJSON(json: any): PublicSetting {
    return PublicSettingFromJSONTyped(json, false);
}

export function PublicSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicSetting {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'instanceName': json['instanceName'],
        'logoId': json['logoId'] == null ? undefined : json['logoId'],
        'defaultLanguage': LanguageFromJSON(json['defaultLanguage']),
        'defaultTimezone': WindowsTimezoneFromJSON(json['defaultTimezone']),
        'defaultDateFormat': DateFormatFromJSON(json['defaultDateFormat']),
        'defaultTimeFormat': TimeFormatFromJSON(json['defaultTimeFormat']),
        'defaultLengthUnit': LengthUnitFromJSON(json['defaultLengthUnit']),
        'openidConnectConfigured': json['openidConnectConfigured'],
        'mode': ModeFromJSON(json['mode']),
        'pinAuthenticationEnabled': json['pinAuthenticationEnabled'],
    };
}

export function PublicSettingToJSON(json: any): PublicSetting {
    return PublicSettingToJSONTyped(json, false);
}

export function PublicSettingToJSONTyped(value?: PublicSetting | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'instanceName': value['instanceName'],
        'logoId': value['logoId'],
        'defaultLanguage': LanguageToJSON(value['defaultLanguage']),
        'defaultTimezone': WindowsTimezoneToJSON(value['defaultTimezone']),
        'defaultDateFormat': DateFormatToJSON(value['defaultDateFormat']),
        'defaultTimeFormat': TimeFormatToJSON(value['defaultTimeFormat']),
        'defaultLengthUnit': LengthUnitToJSON(value['defaultLengthUnit']),
        'openidConnectConfigured': value['openidConnectConfigured'],
        'mode': ModeToJSON(value['mode']),
        'pinAuthenticationEnabled': value['pinAuthenticationEnabled'],
    };
}

